import React, { useState, useEffect } from 'react'
import { Steps } from 'antd'
import {
	ThunderboltOutlined,
	TeamOutlined,
	CheckCircleOutlined,
	LineChartOutlined
} from '@ant-design/icons'
import { Zoom } from 'react-awesome-reveal'
import { useSmartTranslation } from '../../../cls/TranslationContext'

const { Step } = Steps

const AnimatedSteps = () => {
	const { t } = useSmartTranslation()
	const [current, setCurrent] = useState(0) // Start from step 0
	const maxSteps = 4 // Total number of steps

	useEffect(() => {
		// Increment the current step every 1 second
		const interval = setInterval(() => {
			setCurrent((prev) => {
				if (prev < maxSteps - 1) {
					return prev + 1
				} else {
					clearInterval(interval) // Stop the animation when max steps are reached
					return prev
				}
			})
		}, 1500)

		// Cleanup interval on component unmount
		return () => clearInterval(interval)
	}, [])

	return (
		<Zoom triggerOnce direction="up" duration={600}>
			<Steps current={current}>
				<Step
					title={t('single.subscribe')}
					icon={<ThunderboltOutlined />}
				/>
				<Step
					title={t('home.animatedOnboard')}
					icon={<TeamOutlined />}
				/>
				<Step
					title={t('home.animatedExecute')}
					icon={<CheckCircleOutlined />}
				/>
				<Step
					title={t('home.animatedScale')}
					icon={<LineChartOutlined />}
				/>
			</Steps>
		</Zoom>
	)
}

export default AnimatedSteps
